import gql from "graphql-tag";

export default gql`
  mutation deleteSubdeployment($deploymentId: ID, $subdeploymentId: ID) {
    deleteSubdeployment(deploymentId: $deploymentId, subdeploymentId: $subdeploymentId) {
      id
    }
  }
`;